<template>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Attachments
          </h4>
          <h6 class="card-subtitle">
            Files attached to this audit
          </h6>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th scope="col">
                  #
                </th>
                <th class="text-left" scope="col">
                  File Name
                </th>
                <th class="text-left" scope="col">
                  Description
                </th>
                <th class="text-left" scope="col">
                  Transaction
                </th>
                <th class="text-center" scope="col">
                  Action
                </th>
              </tr>
              </thead>
              <tbody>
              <tr :key="index" v-for="(attachment, index) in attachments">
                <td class="masked">
                  {{ index + 1 }}
                </td>
                <td class="text-left masked">
                  <a :download="attachment.name" href="javascript:void(0)">{{ attachment.name }}</a>
                </td>
                <td :title="attachment.description" class="text-left masked">
                  {{ attachment.description }}
                </td>
                <td :title="attachment.extrinsic" class="masked">
                  <a :href="$BORLAUG + '/tx/' + attachment.extrinsic" target="_blank" v-if="attachment.extrinsic">View
                    Confirmation
                    on
                    Blockchain</a>
                </td>

                <td class="text-center masked">
                  <button @click="downloadFile(attachment)"
                          class="btn btn-sm waves-effect waves-light btn-purple rounded"
                          type="button">
                    <i class="fas fa-download"/>
                  </button>
                  <button @click="setAttachment(attachment.evidence_id)"
                          class="btn rounded btn-sm btn-danger waves-effect waves-light m-l-5"
                          data-target="#approveModal" data-toggle="modal" type="button"
                          v-if="status === 'InProgress' && isAuditor()">
                    <i class="fas fa-trash-alt"/>
                  </button>

                  <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="deleteModal"
                       role="dialog"
                       tabindex="-1">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title" id="exampleModalLabel1">Are you sure you want to delete this
                            file?</h4>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span
                            aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <form>
                            <div class="form-group">
                              <label class="control-label">Comments:</label>
                              <textarea class="form-control" id="message-text1" v-model="comments"></textarea>
                            </div>
                          </form>
                        </div>
                        <div class="modal-footer">
                          <button :disabled="isDeleted" @click="deleteFile()"
                                  class="btn waves-effect waves-light btn-success"
                                  type="button">
                            <span v-if="!isDeleted">Yes</span>
                            <span v-if="isDeleted"><i class="fa fa-spinner fa-spin"/> &nbsp;Loading</span>
                          </button>
                          <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                            No
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--                  <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="approveModal"-->
                  <!--                       role="dialog" tabindex="-1">-->
                  <!--                    <div class="modal-dialog">-->
                  <!--                      <div class="modal-content">-->
                  <!--                        <div class="modal-body card-blue">-->
                  <!--                          <div class="text-center m-t-20 m-b-10">-->
                  <!--                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"/>-->
                  <!--                            <br><br>-->
                  <!--                            <h4>Are you sure you want to delete this file?</h4>-->
                  <!--                            <button @click="deleteFile()" class="btn waves-effect waves-light btn-success m-r-15"-->
                  <!--                                    type="button">-->
                  <!--                              <span>Yes</span>-->
                  <!--                            </button>-->
                  <!--                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">-->
                  <!--                              No-->
                  <!--                            </button>-->
                  <!--                          </div>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6 col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Upload a file
          </h4>
          <h6 class="card-subtitle">
            Upload a file to this audit
          </h6>
        </div>

        <div class="card-body form-group row">
          <div class="col-md-12 upload-form form-group">
            <form @submit.prevent="handleSubmit" class="form-horizontal">
              <div class="form-group row">
                <label class="control-label col-md-2">Upload New File</label>
                <div class="col-md-10 text-left">
                  <div class="input-group mb-1">
                    <div class="custom-file">
                      <input :class="{'is-invalid': submitted && error.length>0}" @change="onFileChange()" accept="*"
                             class="custom-file-input"
                             data-vv-as="Attachment" id="file" name="file" ref="file"
                             type="file">
                      <label class="custom-file-label text-ellipsis">{{ filename }}</label>
                    </div>
                  </div>
                  <div class="text-danger" v-if="submitted && error">
                    {{ error[0] }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label col-md-2">Description</label>
                <div class="col-md-10 text-left">
                  <textarea class="form-control" id="desc" name="desc" placeholder="Attachment Description"
                            rows="4" type="text" v-model="evidence_desc"/>
                </div>
              </div>
              <div class="form-group row float-right">
                <div class="button-group">
                  <button class="btn waves-effect waves-light btn-success" type="submit">
                    Save
                  </button>
                  <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-12 text-center">
            <img alt="" class="loader-gif center" src="../../../assets/images/loader.gif">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import uuid from 'uuid/v4';
  import {mapGetters} from 'vuex';
  import {apiMixin} from '@/utils/api-mixin';

  export default {
    name: 'Attachments',
    props: ['auditId', 'status', 'auditor'],
    mixins: [apiMixin('audit')],
    data() {
      return {
        file: File,
        filename: 'Choose File',
        filetype: '',
        attachments: [],
        approveShow: true,
        attachmentIdForDelete: '',
        auditors: [],
        submitted: false,
        error: [],
        evidence_desc: '',
        documentid: null,
        isDeleted: false,
        comments: null
      };
    },
    computed: {
      ...mapGetters(['currentUser', 'activeGroup'])
    },
    mounted() {
      this.init();
      $('.loader-gif').hide();
    },
    methods: {
      async init() {
        await Promise.all([
          this.getAllAttachments()
        ]);
      },

      handleSubmit() {
        this.submitted = true;
        this.error = [];
        if (!this.file) {
          this.error.push('Attachment field required.');
          return;
        }
        this.saveEvidence();
      },
      async onFileChange() {
        this.file = this.$refs.file.files[0];
        this.error.pop();
        this.filename = this.file.name;
        this.filetype = this.file.type;
        this.documentid = uuid();
      },
      async saveEvidence() {
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Attachment saved', async () => {
          const formData = new FormData();
          formData.append('file', this.file);
          const {data} = await this.$apiFile.post(`/audits/${this.auditId}/evidences`, formData);
          if (data.event) {
            await this.$api.patch(`/audits/${this.auditId}/evidences/${data.event.evidence_id}`, {
              description: this.evidence_desc
            });
          }
          this.$refs.file.value = '';
          this.filename = 'Choose File';
        });
        if (isProposal) {
          this.$router.push({name: 'proposals'});
        }
        this.reset();
        await this.init();
      },
      async getAllAttachments() {
        try {
          const {data} = await this.$api.get(`audits/${this.auditId}/evidences`);
          this.attachments = data;
        } catch (e) {
          console.error(e);
        }
      },

      async downloadFile(attachment) {
        const {data} = await this.$api.get(`/audits/${this.auditId}/evidences/${attachment.evidence_id}/file`);
        const link = document.createElement('a');
        link.href = 'data:application/octet-stream;base64,' + data;
        link.download = attachment.name;
        link.click();
      },
      async deleteFile() {
        this.isDeleted = true;
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        $('#approveModal').modal('toggle');
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Audit removed', async () => {
          await this.$api.delete(`/audits/${this.auditId}/evidences/${this.attachmentIdForDelete}`, {
            data: {
              comments: this.comments
            }
          });
        });
        if (isProposal) {
          this.$router.push({name: 'proposals'});
        }
        this.attachmentIdForDelete = null;
        await this.getAllAttachments();
        this.isDeleted = false;
      },
      async setAttachment(attachmentId) {
        this.attachmentIdForDelete = attachmentId;
      },
      isAuditor() {
        return (this.activeGroup && (this.auditor === this.activeGroup.anonymous_account));
      },
      reset() {
        this.file = null;
        this.evidence_desc = '';
      }
    }
  }
</script>

<style scoped>
  .loader-gif {
    display: none;
    opacity: 0.5;
  }

  .loader-gif.center {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    height: 50%;
  }

  .text-ellipsis {
    line-height: 2;
    color: #6c757d;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .masked {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
